import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../pages/Details.css';
import { supabase } from '../../supabaseClient';

const VRViewer = () => {
  const navigate = useNavigate();
  const [vrInner, setVrInner] = useState(null);

  useEffect(() => {
    const getVrInner = async () => {
      const res = await supabase.from('details_vr_inner').select('*').single();
      setVrInner(res.data || null);
    };
    getVrInner();
  }, []);

  return (
    <div className="vr-container">
      <div className="vr-back-btn">
        <button
          className="btn2"
          type="button"
          onClick={() => navigate('/details')}
          aria-label="Back to exhibitor details"
        >
          <svg className="arrow2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          {vrInner?.back_btn_en || ''}
        </button>
      </div>
      <iframe
        className="vr-frame"
        title={vrInner?.vr_title_en || ''}
        src={vrInner?.vr_url || ''}
        allowFullScreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
  );
};

export default VRViewer;